function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.63 15.72c0 .9-.73 1.63-1.63 1.63-.64 0-1.19-.37-1.45-.9l2.18-2.18c.53.26.9.81.9 1.45z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M7.35 9.44C3.25 9.44 2 10.69 2 14.79v1.86c0 2.05.31 3.39 1.14 4.21L9.1 14.9c.28-1.01 1.07-1.8 2.08-2.08l3.38-3.38H7.35z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.13 5.87l-1.26 1.26C16.83 5.35 16.16 3.4 12 3.4c-4.05 0-4.88 1.95-4.88 4.88v1.17c-.51 0-.98.03-1.4.08V8.28C5.72 5.58 6.37 2 12 2c3.54 0 5.6 1.3 6.13 3.87z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 14.79v1.86c0 4.1-1.25 5.35-5.35 5.35h-9.3c-.84 0-1.57-.05-2.18-.17l4.36-4.36A3.04 3.04 0 0012 18.74c1.67 0 3.02-1.35 3.02-3.02 0-1.02-.5-1.91-1.27-2.47l3.79-3.79C20.93 9.65 22 11 22 14.79z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.77 2.23c-.3-.3-.79-.3-1.09 0L2.23 20.69c-.3.3-.3.79 0 1.09a.758.758 0 001.08-.01L21.77 3.31c.31-.3.31-.78 0-1.08z"
})));